import FormatMixin from '../../../../Application/mixins/FormatMixin';

const { valorUS } = FormatMixin.methods;

export const productTabInformationToSave = (productOfPurchaseOnFiscalEdit) => {
  const { productData } = productOfPurchaseOnFiscalEdit;

  return {
    productData: {
      ...productData,
      price: valorUS(productData.price),
      quantityPurchased: valorUS(productData.quantityPurchased),
      quantityConverted: valorUS(productData.quantityConverted ?? productData.quantityPurchased),
      vDesc: valorUS(productData.discount),
      totalPrice: valorUS(productData.totalPrice),
    },
  };
};

export const fiscalInformationToSave = (productOfPurchaseOnFiscalEdit) => {
  const { fiscal } = productOfPurchaseOnFiscalEdit;
  const { values, ids } = fiscal;

  return {
    fiscal: {
      ...fiscal,
      values: {
        ...values,
        vBC: valorUS(values.vBC ?? 0),
        pICMS: valorUS(values.pICMS ?? 0),
        vICMS: valorUS(values.vICMS ?? 0),
        vBCST: valorUS(values.vBCST ?? 0),
        vICMSST: valorUS(values.vICMSST ?? 0),
        pMVAST: valorUS(values.pMVAST ?? 0),
        pICMSST: valorUS(values.pICMSST ?? 0),
        pST: valorUS(values.pST ?? 0),
        vICMSSTRet: valorUS(values.vICMSSTRet ?? 0),
        vBCSTRet: valorUS(values.vBCSTRet ?? 0),
        pFCPST: valorUS(values.pFCPST ?? 0),
        vFCPST: valorUS(values.vFCPST ?? 0),
        vBCFCPST: valorUS(values.vBCFCPST ?? 0),
        pIPI: valorUS(values.pIPI ?? 0),
        vIPI: valorUS(values.vIPI ?? 0),
        pPIS: valorUS(values.pPIS ?? 0),
        vPIS: valorUS(values.vPIS ?? 0),
        vBCPIS: valorUS(values.vBCPIS ?? 0),
        pCOFINS: valorUS(values.pCOFINS ?? 0),
        vCOFINS: valorUS(values.vCOFINS ?? 0),
        vBCCOFINS: valorUS(values.vBCCOFINS ?? 0),
      },
      ids: {
        ...ids,
        csosnId: values.csosn?.id ?? null,
        origemId: values.origem?.id ?? null,
        cenqId: values.cenq?.id ?? null,
        cfopId: values.cfop?.id ?? null,
        cstId: values.cst?.id ?? null,
        cstIPIId: values.cstIpi?.id ?? null,
        cstPISId: values.cstPis?.id ?? null,
        cstCOFINSId: values.cstCofins?.id ?? null,
      },
    },
  };
};
